module.exports = __webpack_public_path__ + "static/media/1POLICY41.d59b2da3.jpg";